import styled from "styled-components";

type ContainerType = {
  background: string;
  heightShowingHeaderInfo: number;
};

export const Container = styled.div<ContainerType>`
  display: flex;
  flex-direction: column;
  background: ${props => props.background};
  flex: 1;
  overflow: auto;
  height: calc(100vh - ${props => props.heightShowingHeaderInfo}px - 120px);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ContainerFiltersApplied = styled.div`
 padding: 12px 20px 0;
`;

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 20px 20px;
`;

export const SectionsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: stretch;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }

  > * {
    min-width: 0;
    height: 100%;
  }
`;
